import { render, staticRenderFns } from "./MiniFormBox.vue?vue&type=template&id=0c6e400f&scoped=true&"
import script from "./MiniFormBox.vue?vue&type=script&lang=js&"
export * from "./MiniFormBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6e400f",
  null
  
)

export default component.exports